"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localTokenStorage = exports.sessionTokenStorage = exports.BrowserTokenStorage = void 0;
class BrowserTokenStorage {
    constructor(storage) {
        this.storage = storage;
    }
    get() {
        if (this.cache === undefined) {
            const value = this.storage.getItem(BrowserTokenStorage.STORAGE_KEY);
            this.cache = value ? JSON.parse(value) : undefined;
        }
        return this.cache;
    }
    set(auth) {
        this.cache = auth;
        this.storage.setItem(BrowserTokenStorage.STORAGE_KEY, JSON.stringify(auth));
    }
    clear() {
        this.cache = undefined;
        this.storage.removeItem(BrowserTokenStorage.STORAGE_KEY);
    }
}
exports.BrowserTokenStorage = BrowserTokenStorage;
BrowserTokenStorage.STORAGE_KEY = 'UpsideTokens';
exports.sessionTokenStorage = new BrowserTokenStorage(sessionStorage);
exports.localTokenStorage = new BrowserTokenStorage(localStorage);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnJvd3NlclRva2VuU3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90b2tlbi1zdG9yYWdlL0Jyb3dzZXJUb2tlblN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0EsTUFBYSxtQkFBbUI7SUFLOUIsWUFBNkIsT0FBZ0I7UUFBaEIsWUFBTyxHQUFQLE9BQU8sQ0FBUztJQUM3QyxDQUFDO0lBRUQsR0FBRztRQUNELElBQUksSUFBSSxDQUFDLEtBQUssS0FBSyxTQUFTLEVBQUUsQ0FBQztZQUM3QixNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQyxXQUFXLENBQUMsQ0FBQztZQUNwRSxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDO1FBQ3JELENBQUM7UUFFRCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDcEIsQ0FBQztJQUVELEdBQUcsQ0FBQyxJQUEwQjtRQUM1QixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQztRQUNsQixJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQyxXQUFXLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0lBQzlFLENBQUM7SUFFRCxLQUFLO1FBQ0gsSUFBSSxDQUFDLEtBQUssR0FBRyxTQUFTLENBQUM7UUFDdkIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUMsbUJBQW1CLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDM0QsQ0FBQzs7QUF6Qkgsa0RBMEJDO0FBekJ5QiwrQkFBVyxHQUFHLGNBQWMsQ0FBQztBQTJCMUMsUUFBQSxtQkFBbUIsR0FBRyxJQUFJLG1CQUFtQixDQUFDLGNBQWMsQ0FBQyxDQUFDO0FBQzlELFFBQUEsaUJBQWlCLEdBQUcsSUFBSSxtQkFBbUIsQ0FBQyxZQUFZLENBQUMsQ0FBQyJ9